module.exports = __webpack_public_path__ + "static/img/icon-eva2.f3f1168.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-eva2.jpg
// module id = RaSp
// module chunks = 21